export default __webpack_public_path__ + "static/posterNirvana-268489ffab22452f6f2ae3beb7828cf7.svg";